import api from './api';
import { Audit, AuditCreate, AuditList, FileEntity } from '../types';

export const auditsService = {
  list: async (params?: { projekt_id?: number; audit_status?: string }): Promise<AuditList[]> => {
    const response = await api.get('/audits/', { params });
    return response.data;
  },

  get: async (id: number): Promise<Audit> => {
    const response = await api.get(`/audits/${id}`);
    return response.data;
  },

  create: async (data: AuditCreate): Promise<Audit> => {
    const response = await api.post('/audits/', data);
    return response.data;
  },

  update: async (id: number, data: Partial<AuditCreate>): Promise<Audit> => {
    const response = await api.put(`/audits/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/audits/${id}`);
  },

  getFilesToDelete: async (id: number): Promise<FileEntity[]> => {
    const response = await api.get(`/audits/${id}/files-to-delete`);
    return response.data;
  },

  generateReport: async (id: number): Promise<FileEntity[]> => {
    const response = await api.post(`/audits/${id}/report`);
    return response.data;
  },
};
